/* 👻🚨👻🚨👻 Let op! This code has been auto generated, so best not to touch it 👻🚨👻🚨👻 */
import * as Types from './types';

import type { FetchOptions } from 'codegen/fetcher/fetcher.types'
import { fetcher } from 'codegen/fetcher'
import { useQuery, type UseQueryOptions } from '@tanstack/react-query'
export type ContentLinkBlockQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  language: Types.ContentLanguage;
}>;


export type ContentLinkBlockQuery = { __typename?: 'Query', contentLinkBlock?: { __typename?: 'ContentLinkBlock', id: string, title: string, links: Array<{ __typename?: 'ContentLinkBlockLink', anchor: string, url: string }> } | null };


export const ContentLinkBlockDocument = `
query contentLinkBlock($id: ID!, $language: ContentLanguage!) {
  contentLinkBlock(id: $id, language: $language) {
    id
    title
    links {
      anchor
      url
    }
  }
}

`

export const contentLinkBlockQueryRootKey = 'contentLinkBlock'

export function contentLinkBlockQueryFetcher(variables: ContentLinkBlockQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ContentLinkBlockQuery, ContentLinkBlockQueryVariables>(ContentLinkBlockDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function contentLinkBlockQueryKey(variables: ContentLinkBlockQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [contentLinkBlockQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function contentLinkBlockQueryOptions(
    variables: ContentLinkBlockQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ContentLinkBlockQuery, unknown, ContentLinkBlockQuery, (ContentLinkBlockQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: contentLinkBlockQueryKey(variables, fetchOptions),
        queryFn: contentLinkBlockQueryFetcher(variables, fetchOptions),
    }
}

export function useContentLinkBlockQuery<D = ContentLinkBlockQuery, E = unknown>(
    variables: ContentLinkBlockQueryVariables,
    options?: Omit<UseQueryOptions<ContentLinkBlockQuery, E, D, (ContentLinkBlockQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ContentLinkBlockQuery, E, D, (ContentLinkBlockQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...contentLinkBlockQueryOptions(variables, fetchOptions),
    })
}